import $ from 'jquery';

/**
 * If checkbox is ticked, show the text box to enter more information
 */
class CheckboxOtherInputs {
    constructor () {
        this.$checkboxes = $('.js-other-checkbox input');

        this.$checkboxes.on('change', function() {
            CheckboxOtherInputs.checkFields(this);
        });

        $(window).on('load', $.proxy(this.onLoad, this));
    }

    static checkFields (elem) {
        const checked          = $(elem).is(':checked');
        const $otherInputField = $(elem).closest('.js-other-checkbox').next('.js-other-field');

        if (checked) {
            $otherInputField.show().addClass('is-required js-required');
        }
        else {
            $otherInputField.hide().removeClass('is-required js-required');
        }
    }

    onLoad () {
        this.$checkboxes.each(function() {
            CheckboxOtherInputs.checkFields(this);
        });
    }
}

export default CheckboxOtherInputs;
